import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './HeroBanner.css';

const FloatingIcon = ({ className, children }) => (
  <div className={`hero__floating ${className}`} aria-hidden="true">
    {children}
  </div>
);

const HeroBanner = () => {
  const { t } = useLanguage();

  return (
    <section className="hero">
      <div className="hero__container">
        <div className="hero__card">
          <div className="hero__visual" aria-hidden="true">
            <FloatingIcon className="hero__floating--glasses">
              <svg viewBox="0 0 80 44">
                <circle cx="20" cy="24" r="13" />
                <circle cx="60" cy="24" r="13" />
                <path d="M33 24h14M7 20l4 4M69 24l4-4" />
              </svg>
            </FloatingIcon>
            <FloatingIcon className="hero__floating--watch">
              <svg viewBox="0 0 60 100">
                <rect x="20" y="2" width="20" height="22" rx="7" />
                <rect x="10" y="24" width="40" height="52" rx="16" />
                <rect x="20" y="76" width="20" height="22" rx="7" />
                <circle cx="30" cy="50" r="12" />
                <path d="M30 50V42M30 50l7 5" />
              </svg>
            </FloatingIcon>
            <FloatingIcon className="hero__floating--perfume">
              <svg viewBox="0 0 64 70">
                <rect x="22" y="4" width="20" height="10" rx="3" />
                <rect x="16" y="14" width="32" height="10" rx="3" />
                <rect x="10" y="22" width="44" height="38" rx="10" />
              </svg>
            </FloatingIcon>
            <FloatingIcon className="hero__floating--ring">
              <svg viewBox="0 0 64 64">
                <circle cx="32" cy="38" r="16" />
                <path d="M32 4l8 10-8 8-8-8 8-10Z" />
              </svg>
            </FloatingIcon>
            <FloatingIcon className="hero__floating--lighter">
              <svg viewBox="0 0 56 84">
                <rect x="10" y="20" width="36" height="54" rx="8" />
                <rect x="12" y="10" width="18" height="14" rx="4" />
                <path d="M28 10c4 0 8-3 8-8" />
              </svg>
            </FloatingIcon>

            <div className="hero__gift">
              <div className="hero__gift-lid" />
              <div className="hero__gift-box">
                <div className="hero__glow" />
              </div>
              <div className="hero__spark hero__spark--one" />
              <div className="hero__spark hero__spark--two" />
              <div className="hero__spark hero__spark--three" />
            </div>
          </div>

          <div className="hero__content">
            <h1 className="hero__title">{t('hero.title')}</h1>
            <p className="hero__subtitle">{t('hero.subtitle')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
